module.exports = __webpack_public_path__ + "img/3.02.dfaa5713.jpg";